import { UseLoadingReturn } from "@/hooks/use-loading";
import subjectService from "@/services/subject.service";
import { RemoveByIdProps } from "@/types/requests.types";

import useRemove from "../../use-remove";

export type Return = {
  remove: (props: RemoveByIdProps) => Promise<void>;
} & UseLoadingReturn;

const useRemoveSubject = (): Return => {
  const response = useRemove({
    operation: (subjectId) => subjectService.delete(subjectId),
  });

  const { isLoading, startLoading, endLoading, loadingIcon, remove } = response;

  return { isLoading, startLoading, endLoading, loadingIcon, remove };
};

export default useRemoveSubject;
